export default __webpack_public_path__ + "static/media/like.43216b4b.png";